import React, { useState, Fragment } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { pushDataLayerEvent } from '../../../utils/metricManagementUtil'
import { encryptUserInfo } from '../../../utils/encryptUserInfo'

import './footer.scss'

const Footer = ({ isMobile, setCommondModal }) => {
  const [selectCountries, setSelect] = useState(false)

  const { allContentfulVConfidentTransversal } = useStaticQuery(
    graphql`
      query footer {
        allContentfulVConfidentTransversal {
          nodes {
            node_locale
            pais
            tieneRedesSociales
            redesSociales {
              redireccionComponente
              imagenComponente {
                file {
                  url
                }
                description
              }
            }

            menuFooter {
              tituloComponente
              redireccionComponente
            }
          }
        }
      }
    `
  )

  const footerInfo = allContentfulVConfidentTransversal.nodes.filter(
    e => e.node_locale === 'es-CO' &&  process.env.LOCALE.includes(e.pais)
  )[0]

  /*var activeIconCountryUrl = footerInfo.referenciaPais.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].iconoDelPais.file.url
  var activeIconCountryAtl = footerInfo.referenciaPais.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].iconoDelPais.title*/

  /*  var urlFacebook = footerInfo.redireccionFacebook
    var urlInstagram = footerInfo.redireccionInstagram
    var urlTwitter = footerInfo.redireccionTwitter
    var urlYoutube = footerInfo.redireccionYoutube
    var urlSpotify = footerInfo.redireccionSpotify
    var urlTikTok = footerInfo.redireccionTikTok*/

  var urlPoliticaPrivacidadDatos = footerInfo.redireccionPoliticaPrivacidadDatos
  var urlTerminosCondiciones = footerInfo.redireccionTerminosYCondiciones

  /*  const handleShowCountriesModal = () => {
      setCommondModal(
        <div className='f-effect-mobile'>
          <div className='f-hidden-options'>
            <span
              onClick={() => setCommondModal(null)}
              className='f-icon f-icon-close icon2-close'
            />
            <ul className='f-countries-list'>
              <li className='f-country-item'></li>
              {!isMobile ? (
                <span className='f-country-separator'></span>
              ) : null}
              {footerInfo.referenciaPais.map((item, index) => {
                return (
                  <Fragment key={index}>
                    <a href={item.dominioDelPais}>
                      <li className='f-country-item'>
                        <img
                          src={item.iconoDelPais.file.url}
                          alt={item.iconoDelPais.title}
                          className='f-flag-icon'
                        />
                        <label>{item.nombreDelPais}</label>
                        {isMobile ? (
                          <span className='f-icon icon-right f-icon-right' />
                        ) : null}
                      </li>
                    </a>
                    {!isMobile ? (
                      <span className='f-country-separator'></span>
                    ) : null}
                  </Fragment>
                )
              })}
            </ul>
          </div>
        </div>,
      )
    }*/

  const dataLayerTyC = (labelText) => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Terminos-Condiciones_VConfident',
      category: 'v-confident',
      action: 'click',
      label: labelText,
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }
  
  return (
    <footer className="f-footer">
      <div className="f-footer-container">
        <div className="f-left-footer-section">
          {footerInfo.menuFooter.map((item, index) => {
            return (
              <a
                href={item.redireccionComponente}
                className="f-left-redirect-footer"
                target="_blank"
                key={`footerItem-${index + 1}`}
                onClick={ () => dataLayerTyC(item.tituloComponente) }
              >
                {item.tituloComponente}
              </a>
            )
          })}
        </div>
        {isMobile && (
          <div className="f-right-footer-section">
            {/*            <div
              onClick={() =>
                isMobile
                  ? handleShowCountriesModal()
                  : selectCountries
                  ? setSelect(false)
                  : setSelect(true)
              }
              className="f-footer-sub-section f-footer-country"
            >
              <img
                src={activeIconCountryUrl}
                alt={activeIconCountryAtl}
                className="f-flag-icon"
              />
              <label className="f-active-country">
                {process.env.COUNTRY_NAME}
              </label>
              <span
                className={
                  selectCountries
                    ? 'f-icon icon-down f-rotate-colapse'
                    : 'f-icon icon-down'
                }
              />
            </div>*/}

            {footerInfo.tieneRedesSociales && (
              <div className="f-footer-sub-section f-btn-footer-social">
                {footerInfo.redesSociales.map((item, i) => {
                  return (
                    <a
                      href={item.redireccionComponente}
                      target="_blank"
                      rel="noreferrer noopener"
                      className="social-media-image"
                      key={`socialMedia-${i + 1}`}
                    >
                      <img
                        src={item.imagenComponente[0].file.url}
                        alt={item.imagenComponente[0].description}
                      />
                    </a>
                  )
                })}
              </div>
            )}
          </div>
        )}
      </div>

      {/*     {selectCountries && (
        <div className="f-effect-mobile">
          <div className="f-hidden-options">
            <span
              onClick={() => setSelect(false)}
              className="f-icon f-icon-close icon2-close"
            />
            <ul className="f-countries-list">
              <li className="f-country-item"></li>
              {!isMobile ? <span className="f-country-separator"></span> : null}
              {footerInfo.referenciaPais.map((item, index) => {
                return (
                  <Fragment key={index}>
                    <a href={item.dominioDelPais}>
                      <li className="f-country-item">
                        <img
                          src={item.iconoDelPais.file.url}
                          alt={item.iconoDelPais.title}
                          className="f-flag-icon"
                        />
                        <label>{item.nombreDelPais}</label>
                        {isMobile ? (
                          <span className="f-icon icon-right f-icon-right" />
                        ) : null}
                      </li>
                    </a>
                    {!isMobile ? (
                      <span className="f-country-separator"></span>
                    ) : null}
                  </Fragment>
                )
              })}
            </ul>
          </div>
        </div>
      )}*/}
    </footer>
  )
}

export default Footer
